import * as React from 'react'
import { FaIcon } from '@/lib/fa'
import { faArrowLeft, faXmark } from '@fortawesome/free-solid-svg-icons'

interface TmsImportHeaderProps {
  onBack: () => void
  translate: (key: string) => string
  title?: string
}

export const TmsImportHeader: React.FC<TmsImportHeaderProps> = ({
  onBack,
  translate,
  title,
}) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-4 tw-border-b tw-bg-[#fafbff] tw-px-6 tw-py-4">
      <button
        onClick={onBack}
        className="tw-flex tw-items-center tw-gap-2 tw-rounded tw-p-2 hover:tw-bg-gray-100"
      >
        <FaIcon icon={faArrowLeft} className="tw-h-4 tw-w-4" />
      </button>
      <h2 className="tw-flex-1 tw-text-lg tw-font-semibold">
        {title ?? translate('newDelegation.import-tms')}
      </h2>
      <button
        onClick={onBack}
        className="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-text-red-500 hover:tw-text-red-600"
      >
        {translate('answer.cancel')}
        <FaIcon icon={faXmark} className="tw-h-4 tw-w-4" />
      </button>
    </div>
  )
}
